module.exports = __webpack_public_path__ + "img/Home-02.3bc08dfc.svg";